<template>
  <form
    class="close-repair"
    @submit.prevent="submit"
  >
    <header class="close-repair__header">
      <span class="close-repair__icon">
        <CheckCheck
          :size="24"
          aria-hidden="true"
        />
      </span>

      <div>
        <h2>Завершение ремонта</h2>
        <p>Проверьте стоимость и выберите способ оплаты</p>
      </div>
    </header>

    <div class="close-repair__body">
      <div class="close-repair__device">
        <Wrench
          :size="18"
          aria-hidden="true"
        />

        <div>
          <strong>Ремонт</strong>
          <span v-if="data.client">{{ data.client }}</span>
        </div>

        <span class="close-repair__number">№ {{ data.id }}</span>
      </div>

      <section
        class="close-repair__total"
        aria-label="Стоимость ремонта"
      >
        <span>К оплате клиентом</span>
        <strong>{{ priceToFormat(price) }}</strong>
        <div><span>Всего затрачено на ремонт</span><b>{{ totalSpent }}</b></div>
      </section>

      <details
        v-if="cashOperations.length"
        class="close-repair__expenses">

        <summary>
          История расходов
          <span>{{ cashOperations.length }}</span>
        </summary>

        <div
          v-for="(operation, index) in cashOperations"
          :key="`operation-${index}`"
          class="close-repair__expense"
        >
          <div>
            <strong>{{ getOperationType(operation) }}</strong>
            <b>{{ priceToFormat(operation.amount) }}</b>
          </div>

          <small>{{ formatDate(operation.createdAt) }}</small>
          <p>{{ operation.description }}</p>
        </div>
      </details>

      <div class="close-repair__payment">
        <span>Способ оплаты</span>
        <p>Как клиент оплачивает ремонт?</p>

        <select
          v-model="form.typePay"
          class="close-repair__select"
          name="repair-payment"
          aria-label="Способ оплаты"
          required
        >
          <option value="">Выберите тип оплаты</option>

          <option
            v-for="method in paymentMethods"
            :key="method.code"
            :value="method.code"
          >
            {{ method.name }}
          </option>
        </select>

        <multi-pay
          v-if="isMultiPay"
          :price="price"
          :terminal.sync="form.payCardTransfer"
          :cash.sync="form.payCash"
          :card-transfer.sync="form.payTerminal"
        />
      </div>

      <p class="close-repair__note">
        <Info :size="16" aria-hidden="true"/>

        <span>После подтверждения ремонт получит статус «Завершён».</span>
      </p>

      <p v-if="error"
         class="close-repair__error"
         role="alert"
      >
        {{ error }}
      </p>
    </div>

    <footer class="close-repair__actions">
      <button
        type="button"
        :disabled="isSubmitting"
        @click="closeModal(null)"
      >
        Отмена
      </button>

      <button
        type="submit"
        class="close-repair__submit"
        :disabled="!canSubmit"
      >
        <Check :size="18" aria-hidden="true"/>
        Завершить ремонт
      </button>
    </footer>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import MultiPay from '@/components/modals/createSale/components/multiPay/index.vue'

import {
  Check,
  CheckCheck,
  Info,
  Wrench
} from 'lucide-vue'
import { priceToFormat, formatDate } from '@/helper'

export default {
  name: 'CloseRepair',
  components: {
    Check,
    CheckCheck,
    Info,
    Wrench,
    MultiPay
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: {
        typePay: '',
        payTerminal: 0,
        payCash: 0,
        payCardTransfer: 0
      },

      isSubmitting: false,
      error: ''
    }
  },
  computed: {
    ...mapGetters('settings', ['getDefaultValues']),
    isMultiPay () {
      return this.form.typePay === 'multi'
    },
    paymentMethods () {
      return this.getDefaultValues['type-pay'] || []
    },
    cashOperations () {
      return this.data.cashOperations || []
    },
    price () {
      return Number(this.data.repairPrice)
    },
    totalSpent () {
      return priceToFormat(this.cashOperations.reduce((sum, { amount }) => sum + Number(amount || 0), 0))
    },
    canSubmit () {
      return this.form.typePay && (this.form.typePay === 'multi' && (this.form.payTerminal !== 0 || this.form.payCash !== 0 || this.form.payCardTransfer !== 0) || this.form.typePay !== 'multi')
    }
  },
  methods: {
    ...mapActions('repair', ['close']),
    ...mapActions('modal', ['closeModal']),
    priceToFormat,
    formatDate,
    getOperationType ({ code }) {
      return this.getDefaultValues.operationType?.find(item => item.code === code)?.name || 'Операция'
    },
    async submit () {
      await this.$bus.emit('start-loader')

      if (this.form.typePay !== 'multi') {
        // ЖЕСТКИЙ КОСТЫЛЬ
        if (this.form.typePay === 'terminal') {
          this.form.payTerminal = this.price
        }

        if (this.form.typePay === 'cash') {
          this.form.payCash = this.price
        }

        if (this.form.typePay === 'cardTransfer') {
          this.form.payCardTransfer = this.price
        }
      }

      this.isSubmitting = true

      const { data, error } = await this.close({
        id: this.data.id,
        data: this.form
      })

      await this.$bus.emit('stop-loader')

      if (error) {
        this.error = `Произошла ошибка: ${error.message}`

        return
      }

      setTimeout(() => {
        this.$notify({
          type: 'success',
          title: 'Ура!',
          text: `За эту продажу Вы, заработали: <span><b>${priceToFormat(data.salary)}<b/></span>`,
          clean: false,
          duration: 3000
        })
      }, 1000)

      this.$bus.emit('update-sale-history')

      await this.closeModal(null)

      this.isSubmitting = false
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss"/>
